import { useEffect, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';

import { LISTENER_EVENT_DEBOUNCE_MS } from '../constants';

/*
 * This hook observes the size of a given HTML element and returns its width and height.
 */
export const useDebouncedResizeObserverFor = (
  ref: React.RefObject<HTMLElement>
) => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const debouncedSetSize = useDebounceCallback(
    setSize,
    LISTENER_EVENT_DEBOUNCE_MS
  );

  useEffect(() => {
    // Use ResizeObserver to detect size changes
    const resizeObserver = new ResizeObserver(() => {
      debouncedSetSize({
        width: ref.current?.clientWidth ?? 0,
        height: ref.current?.clientHeight ?? 0,
      });
    });
    // Start observing the element when it's available
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }
    // Clean up the observer on unmount and when ref changes
    return () => {
      resizeObserver.disconnect();
    };
  }, [ref.current]);

  return size;
};
